export function noop() {
  // no operations
}
